module.exports = __webpack_public_path__ + "img/func_4_1.1bcc0c16.svg";